import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import FalconPagination from "components/common/custom/pagination";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Gear, Pen } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { DeleteBranch, GetAllBranchList } from "../config/branchApi";
import { toast } from "react-toastify";
import { resetIndividual } from "../config/branchSlice";

const BranchListTable = ({
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  data,
  setting,
  page,
  rowsPerPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalRow, setModalRow] = useState(null);

  useEffect(() => {
    dispatch(resetIndividual());
  }, []);

  const handleConfirmDelete = async () => {
    const response = await dispatch(DeleteBranch(modalRow?.branch_id)).unwrap();
    if (response?.success) {
      const body = {
        name: "",
        cchi_no: "",
        nphies_id: "",
        start_point: 0,
        limit: rowsPerPage,
      };
      toast.success(response?.message_en);
      const res = await dispatch(GetAllBranchList(body)).unwrap();
    } else {
      toast.error(response?.message_en);
    }
  };
  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "branch",
      header: "Branch ",
      cell: ({ row: { original } }) => `${original?.branch_name || ""}`,
    },
    {
      accessorKey: "branch_id",
      header: "Branch ID",
      cell: ({ row: { original } }) => `${original?.branch_id || ""}`,
    },
    {
      accessorKey: "cchi",
      header: "CCHI Number",
      cell: ({ row: { original } }) => `${original?.branch_cchino || ""}`,
    },
    {
      accessorKey: "nphies",
      header: "Nphies ID",
      cell: ({ row: { original } }) => `${original?.branch_nphies_code || ""}`,
    },
    {
      accessorKey: "city",
      header: "City",
      cell: ({ row: { original } }) =>
        `${original?.city_name || original?.branch_city || ""}`,
    },
    {
      accessorKey: "actions",
      header: <Gear />,
      enableSorting: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {!!setting?.edit && !!setting?.edit && !!setting?.delete && (
              <CardDropdown
                icon="ellipsis-v"
                dropdownClassName="py-2 custom-dropdown-menu"
              >
                {!!setting?.view && (
                  <Dropdown.Item
                    onClick={() =>
                      navigate(`${paths.addBranch}/${original?.branch_id}/view`)
                    }
                  >
                    <FontAwesomeIcon icon="eye" className="me-2" />
                    View
                  </Dropdown.Item>
                )}
                {!!setting?.edit && (
                  <Dropdown.Item
                    onClick={() =>
                      navigate(`${paths.addBranch}/${original?.branch_id}`)
                    }
                  >
                    <Pen className="me-2" />
                    Edit
                  </Dropdown.Item>
                )}
                {!!setting?.delete && (
                  <Dropdown.Item
                    onClick={() => {
                      setShowDeleteModal(true);
                      setModalRow(original);
                    }}
                  >
                    <FontAwesomeIcon icon="trash" className="me-2" />
                    Delete
                  </Dropdown.Item>
                )}
              </CardDropdown>
            )}
          </>
        );
      },
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);
  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this branch?"
      />
    </div>
  );
};

export default BranchListTable;
